import React, { useState, useEffect } from "react";
import {Button}  from "@progress/kendo-react-buttons";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import WarningIcon from "@mui/icons-material/Warning";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Grid from "@mui/material/Grid";
import Draggable from "react-draggable";
import { Paper, PaperClasses, PaperProps, SxProps, Theme } from "@mui/material";
import { CommonProps } from "@mui/material/OverridableComponent";

function PaperComponent(props: PaperProps) {
  return (
    <Draggable
      handle="#alert-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

interface TimeoutModalProps {
  show: boolean;
  onTimeout: () => void;
  onStayLoggedIn: () => void;
  title: string;
  description: string;
  children: React.ReactNode;
  confirmText?: string;
  getRemainingTime: () => number;
}

const TimeoutModal = ({
  show,
  onTimeout,
  onStayLoggedIn,
  title,
  description,
  children,
  confirmText = "Stay logged in",
  getRemainingTime,
  ...rest
}: TimeoutModalProps) => {
  const [remaining, setRemaining] = useState<number>(5000);

  useEffect(() => {
    
    
    const interval = setInterval(() => {
     let remainingTime = getRemainingTime();
      setRemaining(Math.ceil(remainingTime / 1000));
      
    }, 500);

    return () => {
      clearInterval(interval);
    };
  
  });

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={show}
      aria-label={title}
      aria-labelledby="alert-dialog-title"
      aria-describedby={description}
      PaperComponent={PaperComponent}
      tabIndex={-1}
      {...rest}
    >
      <DialogTitle style={{ cursor: "move" }} id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
       
          <Grid container spacing={0}>
            <Grid item xs={3}>
              <WarningAmberIcon
                sx={{ fontSize: 60 }}
                color="warning"
              ></WarningAmberIcon>
            </Grid>
            <Grid item xs={9}>
            <DialogContentText id="alert-dialog-description">
                Logging out in{" "}
                {new Date(remaining * 1000).toISOString().substring(14, 19)}{" "} minutes.
                </DialogContentText>
            </Grid>
          </Grid>
        
      </DialogContent>
      <DialogActions>
      <button
          type="button"
          className="btn btn-primary k-mr-2"
          onClick={() => {
            onStayLoggedIn();
          }}
        >
         {confirmText}
        </button>
        <button
          type="button"
          className="btn btn-outline-primary"
          onClick={() => {
            onTimeout();
          }}
        >
          Logout
        </button>  
        
      </DialogActions>
    </Dialog>
  );
};

export default TimeoutModal;
